import { IMappedQueryFilters, QueryFilters } from '@/models/filters/QueryFilters';
import { ISearchFilter } from '@/models/filters/Filters';

export interface IMappedSearchQueryFilters extends IMappedQueryFilters {
  searchValue?: string;
  searchFields?: string[];
}

export class SearchQueryFilters extends QueryFilters {
  public searchFilter?: ISearchFilter;

  constructor(initData: Partial<SearchQueryFilters>) {
    super(initData);
    Object.assign(this, initData);
  }

  public mapQueryFilterToRequestParams(): IMappedSearchQueryFilters {
    const filter = super.mapQueryFilterToRequestParams() as IMappedSearchQueryFilters;
    if (this.searchFilter && this.searchFilter.value) {
      filter.searchValue = this.searchFilter.value;
      filter.searchFields = this.searchFilter.headers.map(header => header.value);
    }
    return filter;
  }
}
